export class DrgRequest{
    feeScheduleId:string;
    code:string;

    constructor(feeScheduleId:string,code:string){
        this.feeScheduleId = feeScheduleId;
        this.code = code;
    }
}